import React from "react";
import { useSelector } from "react-redux";
import GameSet from "./GameSet";

const LatestGames = () => {
    const latestGames = useSelector(state => state.seasons.latestGames);
    return <GameSet games={latestGames} direction={-1} title="Últimos Jogos" />
}

export default LatestGames;
